module.exports = __webpack_public_path__ + "img/expired.71a93cc3.png";